import { env } from '~/env'

const WEB_BASE = env.VITE_PUBLIC_APP_URL
const WEB_HOST = WEB_BASE.replace(/^https?:\/\//, '').replace(/\/$/, '')

export const organizerPageUrl = (handle: string) => `${WEB_BASE}/o/${handle}`

export const organizerPageHost = (handle: string) => `${WEB_HOST}/o/${handle}`
